import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import { motion } from "framer-motion";
import styled from "styled-components";
import { FaEnvelope } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import backImage from "./assets/back.jpg";
import logo from "./assets/Logo2.png";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${backImage});
  background-size: cover;
  background-position: center;
`;

const Form = styled(motion.form)`
  font-family: "Inter", sans-serif;
  background: rgba(48, 136, 139, 0.15); /* Glass effect */
  backdrop-filter: blur(12px);
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Logo = styled.img`
  width: 200px;
  margin-bottom: 20px;
`;

const InputField = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: 12px 50px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
    outline: none;
    transition: all 0.3s ease-in-out;

    &:focus {
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 0px 12px rgba(255, 255, 255, 0.4);
    }

    &::placeholder {
      font-weight: normal;
      color: rgba(46, 42, 42, 0.7);
    }
  }

  svg {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: rgba(46, 42, 42, 0.7);
  }
`;

const Button = styled(motion.button)`
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
    transform: scale(1.05);
  }
`;

const BackToLogin = styled(Link)`
  margin-top: 15px;
  color: rgba(46, 42, 42, 0.7);
  font-weight: bold;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    color: white;
  }
`;

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // ✅ Initialize useNavigate

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("https://server229256.nazwa.pl/request-password-reset", {
        email,
      });

      toast.success(response.data.message);

      // ✅ Redirect to login after 3 seconds
      setTimeout(() => {
        navigate("/login");
      }, 3000);
      
    } catch (error) {
      toast.error(error.response?.data?.message || "Błąd serwera.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <ToastContainer />
      <Form initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <Logo src={logo} alt="Logo" />
        <h2>Podaj swój adres e-mail, aby otrzymać link resetujący.</h2>
        <InputField>
          <FaEnvelope />
          <input
            type="email"
            placeholder="Twój email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </InputField>
        <Button type="submit" whileTap={{ scale: 0.95 }} onClick={handleSubmit}>
          {loading ? "Wysyłanie..." : "Wyślij link resetujący"}
        </Button>
        <BackToLogin to="/login">← Powrót do logowania</BackToLogin>
      </Form>
    </Container>
  );
}

export default ForgotPassword;
